import { jwtDecode } from 'jwt-decode'
import clearPersistedLocalStorage from '../utils/persistedLocalStorage'
import { userManager, signOut } from './oidc'

/**
 * Returns the current user as the claim object the rest of the app expects
 * (`sub`, `email`, `given_name`, `resource_access`, `sid`, …).
 *
 * Roles live in the *access* token, not the ID token — Keycloak's client-roles
 * mapper only sets `access.token.claim` — so the access token is what gets
 * decoded here.
 */
export async function getUser () {
  const user = await userManager.getUser()
  if (!user || !user.access_token) {
    throw new Error('user info not found!')
  }
  return jwtDecode(user.access_token)
}

export async function getFormattedUser () {
  return formattedUserInfo(await getUser())
}

export function logout () {
  clearPersistedLocalStorage()
  // RP-initiated logout: ends the Keycloak SSO session, not just the local one.
  signOut()
}

// Roles are read in exactly one place — formattedUserInfo below — which every
// screen reaches through getFormattedUser(). `userRoles()` and `hasRole()` used
// to sit here too, but both awaited a promise without returning its result, so
// they always resolved to undefined; nothing called them. Removing them leaves a
// single role-reading path and takes the trap with it.
function formattedUserInfo(user) {
  return {
    id: user.sub,
    email: user.email,
    fullName: user.name,
    username: user.preferred_username,
    firstName: user.given_name,
    lastName: user.family_name,
    phone: user.phone ? user.phone : '',
    birthMonth: user.birth_month ? user.birth_month : null,
    birthDay: user.birth_day ? user.birth_day : null,
    roles: user.resource_access && user.resource_access['copline-service'] && user.resource_access['copline-service'].roles ? user.resource_access['copline-service'].roles : []
  }
}
